import Icon from 'components/Icon';
import {FC} from 'react';
import {jt, t} from 'ttag';

import RegistrationInfo from '../RegistrationInfo';

type RegistrationCompletedProps = {
    clientName: string;
    email?: string;
    instructionUrl: string | undefined;
    partnerName: string;
};

const RegistrationCompleted: FC<RegistrationCompletedProps> = ({
    clientName,
    email,
    instructionUrl,
    partnerName,
}) => {
    return (
        <>
            <h1 className="mt-2 flex">
                <Icon className="my-0.5 mr-2 text-green-500" icon="success" />
                {t`Email registration complete`}
            </h1>
            <div className="pb-4 pt-2 sm:ml-8">
                <p className="pb-6">
                    {jt`Thank you for registering your email address. You will receive a confirmation email soon.`}
                </p>
                <div className="pb-6">
                    <RegistrationInfo
                        clientName={clientName}
                        email={email}
                        instructionUrl={instructionUrl}
                        partnerName={partnerName}
                    />
                </div>
                <div className="text-sm text-light-secondary">
                    {t`Please note:`}
                    <li>{t`Once an email address is registered, your registration code will no longer work.`}</li>
                    <li>{t`Makeleaps' Email Address Registration is only for a single email address and does not allow edits.`}</li>
                    <li>{t`Please contact the requesting organization if you wish to change your registered email address.`}</li>
                </div>
            </div>
        </>
    );
};

export default RegistrationCompleted;
